module.exports = __webpack_public_path__ + "static/about-insta-5-cb45829789410efe4e953bac97fcafbd.jpg";